import React from 'react';
import { Link } from 'react-router-dom';
interface CTAButtonProps {
  to: string;
  text: string;
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  fullWidth?: boolean;
}
const CTAButton = ({
  to,
  text,
  variant = 'primary',
  size = 'md',
  fullWidth = false
}: CTAButtonProps) => {
  const baseClasses = 'inline-block font-medium rounded-full transition duration-200 text-center';
  const variantClasses = {
    primary: 'bg-blue-600 hover:bg-blue-700 text-white',
    secondary: 'bg-gray-800 hover:bg-gray-900 text-white',
    outline: 'bg-transparent border-2 border-blue-600 text-blue-600 hover:bg-blue-600 hover:text-white'
  };
  const sizeClasses = {
    sm: 'text-sm px-4 py-2',
    md: 'px-6 py-3',
    lg: 'text-lg px-8 py-4'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  const classes = `${baseClasses} ${variantClasses[variant]} ${sizeClasses[size]} ${widthClass}`;
  return <Link to={to} className={classes} data-id="element-222">
      {text}
    </Link>;
};
export default CTAButton;